/**
 * MY — Change Business Address (Section 47(3) / PD 2/2017, M32017) Register Detail 매핑.
 *   panel 의 handleCreateTask 가 task POST 의 officerData 로 presetForm(state) 을 동봉하므로
 *   TASK_DATA.formData.presetForm.state.values.* 에서 추출 가능.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32017', {
  title: 'Change Business Address (Section 47(3)) Details',
  fields: [
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name', 'presetForm.companyName', 'presetForm.state.values.company_name'] },
    { label: 'Registration No.', key: ['companyRegistrationNo', 'presetForm.companyRegistrationNo', 'presetForm.state.values.company_registration_no'] },
    { label: 'Old Business Address', key: ['presetForm.state.values.old_business_address', 'old_business_address'] },
    { label: 'New Address (Line 1)', key: ['presetForm.state.values.address_line_1', 'address_line_1'] },
    { label: 'New Address (Line 2)', key: ['presetForm.state.values.address_line_2', 'address_line_2'] },
    { label: 'New Address (Line 3)', key: ['presetForm.state.values.address_line_3', 'address_line_3'] },
    { label: 'Postcode', key: ['presetForm.state.values.postcode', 'postcode'] },
    { label: 'City', key: ['presetForm.state.values.city', 'city'] },
    { label: 'State', key: ['presetForm.state.values.state', 'state'] },
    { label: 'Country', key: ['presetForm.state.values.country', 'country'] },
    { label: 'Effective Date', key: ['presetForm.effectiveDate', 'presetForm.state.values.effective_date', 'effective_date'] },
    { label: 'Resolution Date', key: ['presetForm.dcrDate', 'presetForm.state.values.dcr_date', 'dcr_date'] },
    { label: 'Declaration Date', key: ['presetForm.declarationDate', 'presetForm.state.values.declaration_date', 'declaration_date'] },
  ],
});
